// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"information-module--infoBox--3jWWC","summary":"information-module--summary--qq77S","articleLinks":"information-module--articleLinks--3BQEs"};